import { DatasetBase } from '@core/reports-types';

import { addYAxisCategory } from '../composables/axes';

// legacy fn
export const createYAxisCategoryFactory = (dataset: DatasetBase) => () =>
  addYAxisCategory(dataset)(<any>{}).yAxis;

export const addYAxisCategoryTruncate = <
  T extends {
    type: 'category';
  },
>(
  opts: T,
) => ({
  ...opts,
  overflow: 'truncate',
  width: 150,
});
